export const PENDING_AUTH_RETURN_KEY = 'fos_pending_auth_return_v1'

export function fragranceShareReturnPath(token) {
  return /^[0-9a-f]{24}$/.test(token || '') ? `/share/fragrance/${token}` : ''
}

export function safeAuthReturnTarget(value) {
  const target = String(value || '')
  return /^\/share\/fragrance\/[0-9a-f]{24}$/.test(target) ? target : ''
}

export function rememberAuthReturn(storage, target) {
  const safe = safeAuthReturnTarget(target)
  if (!safe) {
    storage?.removeItem(PENDING_AUTH_RETURN_KEY)
    return ''
  }
  storage?.setItem(PENDING_AUTH_RETURN_KEY, safe)
  return safe
}
